module.exports = "https://static.wmbcdn.com/uniweb/images/7284ec9519bed7503ec058822faf4cd4.svg";